/* eslint-disable */
import config from "../../config";
import makeAPIRequest from "../../services/makeRequest";

async function getPrintTransactions(accessToken, userId, page, limit, mode = "main", month = null, year = null) {
    let API_ENDPOINT = `${config["API_BASE_ENDPOINT"]}/admin/pharos/all_transactions?page=${page}&limit=${limit}&mode=${mode}`;

    if (month && year) {
        API_ENDPOINT += `&month=${month}&year=${year}`;
    }

    const response = await makeAPIRequest(API_ENDPOINT, "GET", null, accessToken);
    const jsonResponse = await response.json();
    return jsonResponse;
}


export default getPrintTransactions;
